export const DEFAULT_DESKTOP_USER_AGENT =
  'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/89.0.4389.82 Safari/537.36 Prerender (+https://github.com/prerender/prerender)';

export const DEFAULT_MOBILE_USER_AGENT =
  'Mozilla/5.0 (Linux; Android 11; Pixel 5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.72 Mobile Safari/537.36 Prerender (+https://github.com/prerender/prerender)';

type UserWithSettings = {
  settings?: {
    customDesktopUserAgent?: string;
    customMobileUserAgent?: string;
  } | null;
};

type ResolveUserAgentOptions = {
  mobile?: boolean;
};

export function resolveUserAgent(user?: UserWithSettings | null, options?: ResolveUserAgentOptions): string {
  const mobile = options?.mobile ?? false;

  if (mobile) {
    return user?.settings?.customMobileUserAgent || DEFAULT_MOBILE_USER_AGENT;
  }

  return user?.settings?.customDesktopUserAgent || DEFAULT_DESKTOP_USER_AGENT;
}
